//
import dashboard from './dashboard/router';
import myAccount from './myaccount/router';
import domesticviolence from './domesticviolence/router';
import Help from '../../components/Help/HelpComponent.vue';
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import { RouteNames } from '@/router/routeNames';
import { type RouteLocation, type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw = {
  path: '/home',
  component: DashboardLayout,
  children: [
    {
      path: '',
      redirect: (_to: RouteLocation) => {
        return { name: RouteNames.DASHBOARD }; // TODO: consider the query params
      },
    },
    {
      path: '/help/:type?',
      name: RouteNames.HELP,
      component: Help,
    },
    dashboard,
    myAccount,
    domesticviolence,
  ],
};

export default routes;
